<template>
    <div>
        <table width=100% height=100% cellpadding=0 cellspacing=0>
            <tr v-if="selectionType != 2" class="dialoginputfield">
                <td colspan=2>
                    <div style="padding: 10px;">
                        <el-form @submit.native.prevent="findUser()">
                            <el-radio-group style="padding-left:20px" v-model="listType" fill="#5171cb">
                                <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                            </el-radio-group>
                            <el-input v-if="listType == 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="word" clearable class="object-search-select">
                                <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                    <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                    <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                    <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                    <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                                    <el-option :label="$t('message.item_tenant_phone')" value="phone"></el-option>
                                </el-select>
                                <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"></el-button>
                            </el-input>
                        </el-form>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="dialog-td">
                    <div class="inner-panel-header">
                        <div class="inner-panel-title">
                            <div class="inner-panel-title-left" v-t="'message.title_select_user'">
                            </div>
                            <div v-if="listType == 1" class="inner-panel-title-right">
                                <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                            </div>
                        </div>
                    </div>
                    <div v-if="listType == 0" class="inner-panel-dialog" :class="{ 'inner-panel-dialog-wide' : (selectionType == 2), 'inner-panel-dialog-narrow' : (selectionType != 2)}">
                        <dialogtree
                            class="dialog-tree"
                            v-bind:initialData="tenantList"
                            @on-selectnode="handleOnSelectNode"
                            :selectionType=1
                            :showAdminUser="showAdminUser"
                            ref="dialogTree">
                        </dialogtree>
                    </div>
                    <div v-else :class="{ 'inner-panel-dialog-wide' : (selectionType == 2), 'inner-panel-dialog-narrow' : (selectionType != 2)}">
                        <div v-else-if="Object.keys(this.foundUserList).length==0" class="default-message" v-t="'message.info_input_searching_condition'">
                        </div>
                        <table width="100%">
                            <tr class="foundUser-record" v-for="user in foundUserList" v-bind:key="user.tenantId + '_' + user.id" @click="addUserTag(user)">
                                <div v-if="tenantList.length == 1">
                                    <td class="foundUser">{{ user.userName }} / {{ user.displayName }}</td>
                                </div>
                                <div v-else>
                                    <td class="foundUser" width="250px">{{ user.userName }} / {{ user.displayName }}</td>
                                    <td class="foundUser" width="250px">{{ user.tenantName }}</td>
                                </div>
                            </tr>
                        </table>
                    </div>
                </td>
                <td class="dialog-td">
                    <div class="inner-panel-header">
                        <div class="inner-panel-title">
                            <div class="inner-panel-title-left">
                                {{ title }}
                            </div>
                            <div class="inner-panel-title-right">
                                <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.common_action_delete_all'"></span></button>
                            </div>
                        </div>
                    </div>
                    <div id="selected-user" class="inner-panel-dialog" :class="{ 'inner-panel-dialog-wide' : (selectionType == 2), 'inner-panel-dialog-narrow' : (selectionType != 2)}">
                        <div v-if="Object.keys(editTagList) == 0" class="default-message" v-html="$t('message.common_action_add_user')">
                        </div>
                        <div v-else class="selected-item-field" style="height: calc(100% - 20px)">
                            <div class="userTag" v-for="tag in editTagList" v-bind:key="tag.id">
                                <span v-if="tag.displayName == null" class="userTag-name">{{ tag.userName }}</span>
                                <span v-else class="userTag-name">{{ tag.userName }}@{{ tag.tenantName }} / {{ tag.displayName }}</span>
                                <span class="closeTag" @click="removeUserTag(tag)">×</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_TRANSLATION = -3;
const STATUS_UNMATCH_MAPTALK = -4;
const STATUS_UNMATCH_VIDEO = -5;
const STATUS_TOO_MANY_TAGS = -6;
const STATUS_BELL_AUTH_USER_LIMIT = -7
const STATUS_STT_DICTIONARY_LIMIT = -8;

export default {
    components: {
        dialogtree: DialogTree
    },

    props: {
        appData: Object,
        title: String,
        selectedUsers: Array,
        selectionType: Number,
        forbidAllDelete: Boolean,
        talkgroupAttribute: Object,
        showAdminUser : {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            listType: 0,
            condition: "name",
            word: '',
            foundUserList: {},
            tenantList: [],
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            prohibitEditAclForSamlUser: false,
            aclType: [
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_read_user"),
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_write_user"),
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_link_user")
            ] ,
        };
    },

    updated: function() {
        let obj = document.getElementById("selected-user");
        obj.scrollTop = obj.scrollHeight;
    },

    created: function() {
        switch(Number(this.selectionType)) {
            case constants.USER_SELECTION_ACL_RO:
            case constants.USER_SELECTION_ACL_RW:
                this.tenantList.push(this.appData.tenantList[0]);
                break;
            case constants.USER_SELECTION_ACL_LINK:
                for (let exportedTenant of this.appData.exportedTenantList) {
                    if (exportedTenant.state == constants.TENANT_CONNECT_ESTABLISH) {
                        let connectedUser = [];
                        connectedUser.push({
                            tenantId: exportedTenant.tenantId,
                            id: exportedTenant.wantUserId,
                            label: exportedTenant.wantUserName + " / " + exportedTenant.wantUserDisplayName,
                            name: exportedTenant.wantUserName,
                            displayName: exportedTenant.wantUserDisplayName,
                            type: constants.OBJECT_USER,
                            isLeaf: true,
                        });
                        this.tenantList.push({
                            tenantId: exportedTenant.tenantId,
                            id: 1,
                            label: exportedTenant.tenantName,
                            name: exportedTenant.tenantName,
                            type: constants.OBJECT_NODE,
                            isLeaf: false,
                            connectedUser: connectedUser
                        });
                    }
                }
                break;
            case constants.USER_SELECTION_GROUP_OF_USER:
                this.tenantList.push(this.appData.tenantList[0]);
                for (let importedTenant of this.appData.importedTenantList) {
                    if (importedTenant.state == constants.TENANT_CONNECT_ESTABLISH) {
                        this.tenantList.push({
                            tenantId: importedTenant.tenantId,
                            id: 1,
                            label: importedTenant.tenantName,
                            name: importedTenant.tenantName,
                            type: 0,
                            isLeaf: false,
                            connectUserId: importedTenant.wantUserId
                        });
                    }
                }
                this.getUserTalkGroupInfo();
                return;
            case constants.USER_SELECTION_TENANT_ADMIN:
            case constants.USER_SELECTION_FORCE_ACTIVATE:
            case constants.USER_SELECTION_FORCE_RESTRICTIONS:
            case constants.USER_SELECTION_USER_PUBLISH_INFORMATION:
            case constants.USER_SELECTION_BELL_AUTH:
            case constants.USER_SELECTION_DICTIONARY_AUTH:
                this.tenantList.push(this.appData.tenantList[0]);
                for (let user of this.selectedUsers) {
                    let key = this.appData.tenantList[0].tenantId + '-' + user.id;
                    let tagInfo = {
                        id: key,
                        tenantId: this.appData.tenantList[0].tenantId,
                        tenantName: this.appData.tenantList[0].name,
                        userId: user.id,
                        userName: user.name,
                        userOptions: user.userOptions,
                        displayName: user.displayName,
                        orgRestrictions: user.restrictions,
                        orgRights: user.rights,
                        orgPublishInformations: user.publishInformations
                    };
                    Vue.set(this.editTagList, key, tagInfo);
                    Vue.set(this.orgTagList, key, tagInfo);
                }
                return;
        }
        for (let i = 0 ; i < this.selectedUsers.length ; i++) {
            let key = this.selectedUsers[i].id;
            Vue.set(this.editTagList, key , { tenantName: this.selectedUsers[i].tenantName, userName: this.selectedUsers[i].userName, displayName: this.selectedUsers[i].displayName, id: key });
            Vue.set(this.orgTagList, key , { tenantName: this.selectedUsers[i].tenantName, userName: this.selectedUsers[i].userName, displayName: this.selectedUsers[i].displayName, id: key });
        }
        return;
    },

    methods: {
        handleOnSelectNode(data,node) {
            if ((data.id == 1) & (data.tenantId != this.appData.tenantList[0].tenantId)) {
                if (data.connectUserId != this.appData.loginUserObjectId) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_refer_link_tenant_user"));
                    return;
                }
            }
            if (data.type == constants.OBJECT_USER) {
                let tenantName = commonUtil.getTenantName(this.appData, data.tenantId);
                let key = data.tenantId + "-" + data.id;
                if (!(key in this.editTagList)) {
                    if ((this.selectionType == constants.USER_SELECTION_ACL_RO) ||
                        (this.selectionType == constants.USER_SELECTION_ACL_RO) ||
                        (this.selectionType == constants.USER_SELECTION_ACL_LINK)) {
                        this.addUserTag({ tenantId: data.tenantId, tenantName: tenantName, userId: data.id, userName: data.name, displayName: data.displayName, id: key });
                    } else {
                        this.addUserTagAfterFetch(data.tenantId , tenantName , data.id);
                    }
                } else {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                }
            }
        },
        getUserTalkGroupInfo() {
            let self = this;
            self.existImportGroup = false;
            server.post('/getusertalkgroupinfo', { talkgroupTenantId: this.appData.tenantList[0].tenantId, id: this.talkgroupAttribute.id })
                .then((res) => {
                    switch (res.data.status) {
                        case 0:
                        case 1:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return;
                    }
                    let sortedUserTalkGroup = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_USER).sortedUserTalkGroup;
                    for (let userTalkgroup of sortedUserTalkGroup) {
                        let key = userTalkgroup.userTenantId + '-' + userTalkgroup.userId;
                        if (!self.isEnableSave(userTalkgroup.userTenantId)) {
                            self.existImportGroup = true;
                        }
                        let tagInfo = {
                                id: key,
                                tenantId: userTalkgroup.userTenantId ,
                                userId: userTalkgroup.userId ,
                                userName: userTalkgroup.userName ,
                                tenantName: userTalkgroup.userTenantName ,
                                defaultFlag: userTalkgroup.defaultFlag ,
                                displayName: userTalkgroup.displayName
                        };
                        Vue.set( self.editTagList, key, tagInfo);
                        Vue.set( self.orgTagList, key, tagInfo);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                });
        },
        findUser: function() {
            let dataList = [];
            this.existImportGroup = false;
            for(let i = 0; i < this.tenantList.length; i++) {
                let param = {tenantId: this.tenantList[i].tenantId}
                if (this.condition == "name") {
                    param.name = this.word;
                } else if (this.condition == "displayName") {
                    param.displayName = this.word;
                } else if (this.condition == "organization") {
                    if (this.word != "") {
                        param.organization = this.word;
                    }
                } else if (this.condition == "title") {
                    if (this.word != "") {
                        param.title = this.word;
                    }
                } else if (this.condition == "phone") {
                    if (this.word != "") {
                        param.phone = this.word;
                    }
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_search_condition_not_found"));
                    return;
                }
                dataList.push(param)
            }

            let self = this;
            self.foundUserList = {}
            let getUserList = {}
            let tooManyUsers = false;
            let getResultCount = 0;
            for (let i = 0; i < dataList.length; i++) {
                let data = dataList[i]
                let tenantListIdx = i;
                server.post('/finduser', data)
                    .then((res) => {
                        getResultCount ++;
                        if (res.data.status != 0) {
                            switch (res.data.status) {
                                case -7:
                                    tooManyUsers = true;
                                    break;
                                case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findUser").replace("{code}",res.data.status));
                                    break;
                            }
                            return;
                        }
                        let tenantName = commonUtil.getTenantName(self.appData, data.tenantId);
                        for (let i = 0; i < res.data.userInfo.length; i++) {
                            let userInfo = res.data.userInfo[i]
                            if (!self.showAdminUser &&
                                res.data.userInfo[i].restrictions != null &&
                                res.data.userInfo[i].restrictions.includes(constants.RESTRICTION_LOGIN)
                            ) {
                                continue;
                            }

                            let key = data.tenantId + '-' + userInfo.id
                            Vue.set(getUserList, key, {
                                    id: key,
                                    tenantId: data.tenantId,
                                    userId: userInfo.id,
                                    tenantName: tenantName ,
                                    userName: userInfo.name ,
                                    userOptions: userInfo.userOptions ,
                                    defaultFlag: false,
                                    displayName: userInfo.displayName,
                                    orgRestrictions: userInfo.restrictions,
                                    orgRights: userInfo.rights,
                                    orgPublishInformations: userInfo.publishInformations
                            });
                        }
                        if (getResultCount == this.tenantList.length) {
                            if (tooManyUsers) {
                                self.foundUserList = {};
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"info_too_many_users"));
                                return;
                            }
                            if (Object.keys(getUserList).length == 0) {
                                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                                return;
                            }

                            // set sorted result to user-list
                            var tempArray = [];
                            for (let objectKey in getUserList) {
                                tempArray.push(objectKey);
                            }
                            tempArray.sort(function(a,b){
                                if( a < b ) return -1;
                                if( a > b ) return 1;
                                return 0;
                            });
                            for (var i = 0; i < tempArray.length; i++) {
                                Vue.set(self.foundUserList, tempArray[i], getUserList[tempArray[i]]);
                            }
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "findUser", error);
                    });
            }
        },

        selectTagAll: function() {
            let addUserCount = 0;
            for (let key in this.foundUserList) {
                let condition = this.checkConditionToAdd(this.foundUserList[key])
                if (condition === STATUS_SUCCESS) {
                    this.addUserTagInternal(this.foundUserList[key])
                    addUserCount ++;
                } else if (condition === STATUS_TOO_MANY_TAGS) {
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    return;
                } else if (condition === STATUS_BELL_AUTH_USER_LIMIT) {
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_bell_max_auth_user_count").replace("{limit}", constants.BELL_MAX_AUTH_USER_LIMIT));
                    return;
                } else if (condition === STATUS_STT_DICTIONARY_LIMIT) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_dictionary_max_auth_user_count").replace("{limit}", constants.STT_DICTIONARY_MAX_AUTH_USER_LIMIT));
                    return;
                }
            }
            if (addUserCount != Object.keys(this.foundUserList).length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_user")));
            }
        },

        addUserTag(user) {
            switch(this.checkConditionToAdd(user)) {
                case STATUS_SUCCESS:
                    this.addUserTagInternal(user);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                    break;
                case STATUS_UNMATCH_SPEECH_TO_TEXT:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_user_speechText"));
                    break;
                case STATUS_UNMATCH_TRANSLATION:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_user_translation"));
                    break;
                case STATUS_UNMATCH_MAPTALK:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_user_mapTalk"));
                    break;
                case STATUS_UNMATCH_VIDEO:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_user_video"));
                    break;
                case STATUS_TOO_MANY_TAGS:
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    break;
                case STATUS_BELL_AUTH_USER_LIMIT:
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_bell_max_auth_user_count").replace("{limit}", constants.BELL_MAX_AUTH_USER_LIMIT));
                    return;
                case STATUS_STT_DICTIONARY_LIMIT:
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_dictionary_max_auth_user_count").replace("{limit}", constants.STT_DICTIONARY_MAX_AUTH_USER_LIMIT));
                    return;
            }
        },

        addUserTagAfterFetch(tenantId , tenantName , userId) {
            let self = this;
            server.post('/getinfo', {tenantId: tenantId, id: userId})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let key = tenantId + '-' + userId;
                        let tagInfo = {
                            id: key,
                            tenantId: tenantId,
                            userId: userId,
                            tenantName: tenantName ,
                            userName: res.data.name ,
                            userOptions: res.data.userOptions ,
                            defaultFlag: false,
                            displayName: res.data.displayName,
                            orgRestrictions: res.data.restrictions,
                            orgRights: res.data.rights,
                            orgPublishInformations: res.data.publishInformations
                        };
                        this.addUserTag(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addUserInfoTag").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "addUserInfoTag", error);
                });
        },

        checkConditionToAdd(tagInfo) {
            if (!(tagInfo.id in this.removeTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= constants.LIMIT_EDIT_TAGS) {
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            let key = tagInfo.tenantId + '-' + tagInfo.userId
            if (key in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            if (this.selectionType === constants.USER_SELECTION_GROUP_OF_USER) {
                // check user/group option (user selection for group)
                if ((this.talkgroupAttribute.talkgroupOptions.speechToTextEngine > 0) & (!tagInfo.userOptions.speechToText)) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
                if ((this.talkgroupAttribute.talkgroupOptions.translationEngine > 0) & (!tagInfo.userOptions.translation)) {
                    return STATUS_UNMATCH_TRANSLATION;
                }
                if ((this.talkgroupAttribute.talkgroupOptions.mapTalk) & (!tagInfo.userOptions.mapTalk)) {
                    return STATUS_UNMATCH_MAPTALK;
                }
                if ((this.talkgroupAttribute.talkgroupOptions.video) & (!tagInfo.userOptions.video)) {
                    return STATUS_UNMATCH_VIDEO;
                }
            } else if (this.selectionType === constants.USER_SELECTION_BELL_AUTH) {
                if (Object.keys(this.editTagList).length >= constants.BELL_MAX_AUTH_USER_LIMIT) {
                    return STATUS_BELL_AUTH_USER_LIMIT;
                }
            } else if (this.selectionType === constants.USER_SELECTION_DICTIONARY_AUTH) {
                if (Object.keys(this.editTagList).length >= constants.STT_DICTIONARY_MAX_AUTH_USER_LIMIT) {
                    return STATUS_STT_DICTIONARY_LIMIT;
                }
            }
            return STATUS_SUCCESS;
        },

        addUserTagInternal(user) {
            let key = user.tenantId + '-' + user.userId
            Vue.set(this.editTagList, key, user)
            if (!(key in this.orgTagList)) {
                Vue.set(this.addTagList, key, user);
            }
            Vue.delete(this.removeTagList, key);
            this.$emit('changeSelectedUser');
            this.scrollOnAction = true;
        },

        removeAllUserTag() {
            switch(this.selectionType) {
                case constants.USER_SELECTION_ACL_RW:
                    if (this.forbidAllDelete) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_all_users"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_TENANT_ADMIN:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_no_users"));
                    return;
            }

            for (let tagKey in this.editTagList) {
                let result = this.removeUserTag(this.editTagList[tagKey])
                if (result !== STATUS_SUCCESS) {
                    return;
                }
            }
        },

        removeUserTag(tag) {
            if (!(tag.id in this.addTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= constants.LIMIT_EDIT_TAGS) {
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            // check remove-all condition
            switch(this.selectionType) {
                case constants.USER_SELECTION_ACL_RW:
                    if ((this.forbidAllDelete) && (Object.keys(this.editTagList).length == 1)) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_rw_user_on_root"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_GROUP_OF_USER:
                    if (this.existImportGroup) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_all_user_by_link"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_TENANT_ADMIN:
                    if (Object.keys(this.editTagList).length == 1) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_no_users"));
                        return;
                    }
                    for (let tenant of this.appData.importedTenantList) {
                        if (tenant.wantUserName == tag.userName) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_tenantAdmin"));
                            return;
                        }
                    }
            }

            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }

            Vue.delete(this.editTagList, tag.id)
            Vue.delete(this.addTagList, tag.id);
            this.$emit('changeSelectedUser');

            return STATUS_SUCCESS
        },

        getTenantName(tenantId) {
            for (let tenant of this.appData.tenantList) {
                if (tenant.tenantId == tenantId) {
                    return tenant.name;
                }
            }
            for (let tenant of this.appData.importedTenantList) {
                if (tenant.tenantId == tenantId) {
                    return tenant.tenantName;
                }
            }
            for (let tenant of this.appData.exportedTenantList) {
                if (tenant.tenantId == tenantId) {
                    return tenant.tenantName;
                }
            }
        },
        getPrivilegeDisplayName(privilege) {
            return commonUtil.getPrivilegeDisplayName(this.$i18n, privilege);
        },
        isEnableSave(tenantId) {
            if (tenantId == this.appData.tenantList[0].tenantId) {
                return true;
            } else {
                if (commonUtil.isTenantConnectAdmin(this.appData, tenantId)) {
                    return true;
                }
            }
            return false;
        },
        isRestrictions(privilege) {
            switch(privilege) {
                case constants.RESTRICTION_LOGOUT:
                case constants.RESTRICTION_PEER_TO_PEER:
                case constants.RESTRICTION_MAP_TAB:
                case constants.RESTRICTION_CHAT_TAB:
                case constants.RESTRICTION_CHAT_SEND:
                    return true;
                case constants.PRIVILEGE_TENANT_ADMIN:
                case constants.PRIVILEGE_ALERT:
                    return false;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel-dialog-wide {
	position:relative;
    height: calc(80vh - 180px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}
.inner-panel-dialog-narrow {
	position:relative;
    height: calc(80vh - 240px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.foundUser-record {
  cursor: pointer;
  word-break: break-all;
}
.foundUser-record:hover {
  background-color: #ecf1fa;
}

.foundUser {
  padding: 10px 20px;
}

.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

